/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Activity_New_EventInputs */



/**
* | output |
* | --- |
* | "New" |
*
* @param {Assistant_Activity_New_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_activity_new_event = /** @type {((inputs?: Assistant_Activity_New_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Activity_New_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nouveau")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neu")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nuovo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Новый")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nuevo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("新的")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しい")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Novo")
	return /** @type {LocalizedString} */ ("New")
});